import { Clock, Bell, Edit2, Trash2, ExternalLink } from "lucide-react";

export function EventCard({ event, onEdit, onDelete }) {
  const isGoogleEvent = event.source === "google";

  return (
    <div
      className="p-4 rounded-xl bg-slate-800/50 border-l-4 hover:bg-slate-800 transition-colors"
      style={{ borderLeftColor: event.color }}
      data-testid={`event-card-${event.id}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3 className="text-white font-medium">{event.title}</h3>
            {isGoogleEvent && (
              <span className="text-xs px-1.5 py-0.5 rounded bg-blue-500/20 text-blue-400">
                Google
              </span>
            )}
          </div>
          {event.description && (
            <p className="text-slate-400 text-sm mt-1 line-clamp-2">
              {event.description}
            </p>
          )}
          <div className="flex items-center gap-4 mt-2 text-xs text-slate-500">
            {event.time && (
              <span className="flex items-center gap-1">
                <Clock size={12} />
                {event.time}
              </span>
            )}
            {event.is_all_day && <span>All day</span>}
            {event.reminder && (
              <span className="flex items-center gap-1 text-amber-400">
                <Bell size={12} />
                Reminder
              </span>
            )}
            {event.calendar_name && (
              <span className="text-slate-500">{event.calendar_name}</span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-1">
          {isGoogleEvent && event.html_link ? (
            <a
              href={event.html_link}
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg transition-colors"
              data-testid={`open-google-event-${event.id}`}
            >
              <ExternalLink size={14} />
            </a>
          ) : (
            <>
              <button
                onClick={() => onEdit(event)}
                className="p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg transition-colors"
                data-testid={`edit-event-${event.id}`}
              >
                <Edit2 size={14} />
              </button>
              <button
                onClick={() => onDelete(event.id)}
                className="p-2 text-slate-400 hover:text-red-400 hover:bg-slate-700 rounded-lg transition-colors"
                data-testid={`delete-event-${event.id}`}
              >
                <Trash2 size={14} />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
